export default function ($scope, uploadScannedLetter) {
    $scope.file = null;
    $scope.referenceNumber = null;

    /* --- */

    $scope.upload = upload;

    /* --- */

    function upload() {
        if (!$scope.file) {
            return;
        }

        if ($scope.scannedLetterForm.$invalid) {
            return;
        }

        uploadScannedLetter($scope.file, $scope.referenceNumber);
    }
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/controllers/letters/upload/uploadCtrl.js